import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { containsPharmaceuticalProduct } from "src/data/helpers";
import { getCoupon } from "src/redux/coupons/selectors";
import { getIsUserAccountActive } from "src/redux/user/selectors";
import CouponBanner from "src/react/components/coupon-banner";
import { generateCouponMessage } from "./message";

export function CouponAppliedMessage({ isUserAccountActive, coupon = {} }) {
  const couponProducts = coupon && coupon.products ? coupon.products.data : [];
  if (
    isUserAccountActive ||
    !coupon.discount_amount ||
    containsPharmaceuticalProduct(couponProducts)
  )
    return null;

  const couponMessage = coupon.message || generateCouponMessage(coupon);

  if (!couponMessage) return null;

  return <CouponBanner>{couponMessage}</CouponBanner>;
}

CouponAppliedMessage.propTypes = {
  isUserAccountActive: PropTypes.bool,
  coupon: PropTypes.shape({
    message: PropTypes.string,
    discount_amount: PropTypes.number,
  }),
};

const mapStateToProps = (state) => ({
  coupon: getCoupon(state),
  isUserAccountActive: getIsUserAccountActive(state),
});

export default connect(mapStateToProps)(CouponAppliedMessage);
